module.exports = __webpack_public_path__ + "img/i-report-pop.02f970fe.png";